import { featured, hotRanks } from "../../../mocks/homeData";

export default function FeatureHot() {
  return (
    <section id="hot" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <span className="text-xs font-bold tracking-widest text-primary-600">LIVE HEAT</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              实时热榜 &amp; 置顶复盘
            </h2>
          </div>
          <span className="hidden items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs font-semibold text-foreground-600 sm:inline-flex">
            <i className="ri-refresh-line text-accent-600"></i> 每 10 分钟刷新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-5">
          {/* 大卡：置顶复盘 */}
          <article className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:col-span-3">
            <div className="relative overflow-hidden">
              <img
                src={featured.img}
                alt={featured.title}
                className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-72"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-600 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-pushpin-2-fill text-accent-200"></i> {featured.tag}
              </span>
            </div>
            <div className="p-5 md:p-6">
              <h3 className="font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{featured.desc}</p>
              <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
                <span className="text-xs text-foreground-500">{featured.meta}</span>
                <a
                  href="#talk"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-4 py-2 text-sm font-semibold text-primary-700 hover:bg-primary-100 transition-colors cursor-pointer"
                >
                  进复盘围观 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </article>

          {/* 小卡列：热度排行 */}
          <div className="rounded-2xl border border-background-200 bg-background-50 p-3 md:p-4 lg:col-span-2">
            <h3 className="flex items-center justify-between px-2 py-2 text-sm font-bold text-foreground-950">
              <span className="inline-flex items-center gap-1.5"><i className="ri-fire-fill text-accent-500"></i> 热度排行</span>
              <span className="text-xs font-normal text-foreground-400">TOP 5</span>
            </h3>
            <ul className="divide-y divide-background-200">
              {hotRanks.map((it) => (
                <li key={it.rank}>
                  <a
                    href="#talk"
                    className="flex items-center gap-3 rounded-xl px-2 py-3 transition-colors hover:bg-background-100 cursor-pointer"
                  >
                    <span
                      className={`w-7 shrink-0 text-center font-heading text-lg font-black ${
                        it.rank === 1 ? "text-accent-500" : it.rank === 2 ? "text-primary-400" : "text-foreground-300"
                      }`}
                    >
                      {it.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-foreground-900">{it.title}</p>
                      <p className="mt-0.5 text-xs text-foreground-400">
                        {it.tag} · 热度 {it.heat} <span className="text-primary-500">{it.delta}</span>
                      </p>
                    </div>
                    <i className="ri-arrow-right-s-line text-foreground-300"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}